import { render, staticRenderFns } from "./TaxSettings.vue?vue&type=template&id=7a712882&"
import script from "./TaxSettings.vue?vue&type=script&lang=js&"
export * from "./TaxSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports